package nl.astraeus.wiki.messages

import nl.astraeus.wiki.oauth.OauthClient

enum class OAuthType {
  GITHUB,
  GOOGLE,
  FACEBOOK
}

class GetOAuthInfoMessage() : Message(
  MessageType.OAUTH_INFO,
  MessageHeader.OAUTH_TYPE,
) {

  constructor(msg: String) : this() {
    message = msg
  }

  constructor(type: OAuthType) : this() {
    setHeader(MessageHeader.OAUTH_TYPE, type.name)
  }
}

class OAuthInfoMessage() : Message(
  MessageType.OAUTH_INFO_RESPONSE,
  MessageHeader.OAUTH_TYPE,
  MessageHeader.CLIENT_ID,
  MessageHeader.CLIENT_SECRET,
  MessageHeader.OAUTH_STATE,
) {

  constructor(msg: String) : this() {
    message = msg
  }

  constructor(
    id: String,
    oauth: OauthClient,
  ) : this() {
    setHeader(MessageHeader.MESSAGE_ID, id)
    setHeader(MessageHeader.CLIENT_ID, oauth.clientId)
    setHeader(MessageHeader.CLIENT_SECRET, oauth.clientSecret)
    setHeader(MessageHeader.OAUTH_STATE, oauth.oauthState)
  }

  fun toOauthClient(): OauthClient {
    return OauthClient(
      getHeader(MessageHeader.CLIENT_ID),
      getHeader(MessageHeader.CLIENT_SECRET),
      getHeader(MessageHeader.OAUTH_STATE)
    )
  }
}
